'use client'

import Image from 'next/image'
import { cn } from '@/lib/utils'

const CUSTOMER_LOGOS = [
  { name: 'Daikin', src: '/logos/customers/daikin.svg', width: 100 },
  { name: 'Air India', src: '/logos/customers/air-india.svg', width: 100 },
  { name: 'Banorte', src: '/logos/customers/banorte.svg', width: 110 },
  { name: 'Front of House', src: '/logos/customers/front-of-house.svg', width: 130 },
  { name: 'Citrus Health Network', src: '/logos/customers/citrus-health.svg', width: 160 },
  { name: 'WV DEP', src: '/logos/customers/wv-dep.svg', width: 140 },
  { name: 'UltraTech Cement', src: '/logos/customers/ultratech-cement.svg', width: 150 },
]

export function TrustedByBar({ className }: { className?: string }) {
  return (
    <div className={cn('space-y-3', className)}>
      <p className='text-center text-xs font-medium uppercase tracking-widest text-white/40'>
        Trusted by leading enterprises
      </p>
      <div className='flex flex-wrap items-center justify-center gap-6 opacity-50'>
        {CUSTOMER_LOGOS.map((logo) => (
          <Image
            key={logo.name}
            src={logo.src}
            alt={logo.name}
            width={logo.width}
            height={28}
            className='h-6 w-auto shrink-0'
          />
        ))}
      </div>
    </div>
  )
}
